require('./accessKeyChangeStep2.scss');

//@vendors
const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;

//@components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');

//@helpers
const operative =  formatText('operatives-changePassword');

//@constants
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING , CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
const { ACCESS_KEY_CHANGE } = require('constants/operationTypes');


const AccessKeyChangeStep2 = () => {
    return (
        <div className="access-key-step-two">
            <h4 className="access-key-step-two__header">
                <FormattedText value="profileKeys-step2Title"/>
            </h4>

            <ContactCenterRender>
                <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
            </ContactCenterRender>

            <SignaturePattern
                operationType={ACCESS_KEY_CHANGE}
                operationParams={{}}
            />{/*@hardcoded until we get the service specification*/}
        </div>
    );
};

module.exports = AccessKeyChangeStep2;
